import { render, staticRenderFns } from "./CashDocumentIcon.vue?vue&type=template&id=5281aa46"
import script from "./CashDocumentIcon.vue?vue&type=script&lang=ts"
export * from "./CashDocumentIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports